export default function getPassFailEmoji(didPass: boolean) {
  return didPass ? '\u2705' : '\u274C';
}
